<template>
  <div>
    <div class="heading-section">
      <h1 class="text-uppercase">Your upcoming order</h1>
      <div class="order-number" :aria-label="'#' + orderNumber">
        #{{ orderNumber }}
      </div>
    </div>
    <div class="confirmation-band">
      <h1 class="order-placed-date">order placed {{ formatedOrderDate }}</h1>
      <div>{{ scheduledDateMessage }}</div>
      <h5 v-if="isDelivery">
        {{ scheduledDate | toStringDayOfWeekDateTimeRange }}
      </h5>
      <h5 v-else>{{ scheduledDate | toStringDayOfWeekDateTime }}</h5>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orderDate: Date,
    scheduledDate: Date,
    orderNumber: String,
    isDelivery: Boolean,
  },
  computed: {
    formatedOrderDate() {
      return this.orderDate.toLocaleDateString('en-US')
    },
    scheduledDateMessage() {
      return this.isDelivery
        ? 'Your order will be delivered'
        : "We'll have your order ready for pickup"
    },
  },
}
</script>

<style lang="scss">
.confirmation-band {
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: white;
  margin-bottom: 15px;
  h2 {
    text-transform: uppercase;
  }
  .order-placed-date {
    text-transform: uppercase;
    font-family: $font-family-sans-serif;
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 10px;
  }
}
.heading-section {
  padding: 15px;
  text-align: center;
  background-color: $catering-bg-grey;
  border-bottom: 1px solid $catering-checkout-line-color;
  .order-number {
    color: $catering-grey-brown;
  }
}
</style>
